import React from 'react';
import styled from 'styled-components';
import { Theme } from '@routific/hive';
import SkeletonTimeline from './RouteTimeline/SkeletonTimeline';

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  overflow-y: auto;
  background: ${Theme.Colors.gray0};
`;

interface SkeletonOverlayProps {
  show: boolean;
}

const SkeletonOverlay: React.FC<SkeletonOverlayProps> = ({ show }) => {
  if (!show) return null;
  return (
    <Overlay>
      <SkeletonTimeline />
    </Overlay>
  );
};

export default SkeletonOverlay;
